import { render, staticRenderFns } from "./SpTwoModule2.vue?vue&type=template&id=c011fca4&scoped=true"
import script from "./SpTwoModule2.vue?vue&type=script&lang=js"
export * from "./SpTwoModule2.vue?vue&type=script&lang=js"
import style0 from "./SpTwoModule2.vue?vue&type=style&index=0&id=c011fca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c011fca4",
  null
  
)

export default component.exports